import { STOP_DRAG } from '../constants';

export default function stopDrag(domainName) {
  return {
    type: STOP_DRAG,
    domainName,
  };
}
